import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bt_001_d",
  "use": "icon-bt_001_d-usage",
  "viewBox": "0 0 112 33",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 112 33\" id=\"icon-bt_001_d\"><defs><style>#icon-bt_001_d .cls-1{fill:none;opacity:0;}#icon-bt_001_d .cls-2{fill:#aaa;}</style></defs><g id=\"icon-bt_001_d_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-bt_001_d_icon\"><path class=\"cls-1\" d=\"M112,33H0V0H112V33Z\" /><path class=\"cls-2\" d=\"M109,2V30H2V2H109m1-1H1V31H110V1Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol